import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import questionBankIcon from '../../assets/img/question_bank/question_icon_blue.svg';
import ComponentHeader from '../../common/ComponentHeader';
import CustomButton from '../../common/CustomButton';
import { isRevisionModeActive, renderHTMLContent } from '../../common/function';
import { messages } from '../../common/messages';
import FlashCard from '../../components/FlashCard';
import ValidateSaveReportIcon from '../../views/Common/ValidateSaveReportIcon';
import CustomCard from '../QuestionBank/CustomCard';
import CustomCardBody from '../QuestionBank/CustomCardBody';
import CustomCardHeader from '../QuestionBank/CustomCardHeader';
import LoaderWrapper from '../QuestionBank/LoaderWrapper';
import ReportComponent from '../ReportComponent';
import GMATCalculator from '../../common/Calculator/GMATCalculator';
import { EXAM_NAMES, QUESTION_TYPE, SUBSCRIPTION_STATUS } from '../../common/constant';
import { getUserSelectedChoices } from './utils/questionUtils';
import { graphicalStatementConfig } from './utils/questionConfigs';
import RatingComponent from '../RatingComponent';

export default class GraphicalStatement extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      questionData: [],
      selectedAnswer1: '',
      selectedAnswer2: '',
      validated: false,
      isUserSelectedChoice: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      isFlashCardHidden: true,
      isReportCardHidden: true,
      isError: false,
      showCalculator: false,
    };

    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
    const { questionMode = EXAM_NAMES.GMAT_FOCUS } = this.props;
    this.isRevisionMode = isRevisionModeActive(questionMode);
  }

  setDropdown1Ref = (element) => {
    this.dropdown1Ref = element;
  };

  setDropdown2Ref = (element) => {
    this.dropdown2Ref = element;
  };
  async componentDidMount() {
    this.setupDropdownListeners();
    const {
      apiServices,
      params,
      questionType: question_type,
      questionMode = EXAM_NAMES.GMAT_FOCUS,
    } = this.props;
    const { readingid, subscription } = params;
    const payload = {
      reading_id: readingid,
      question_type,
      subscriptionstatus: +subscription ? SUBSCRIPTION_STATUS.PAID : SUBSCRIPTION_STATUS.FREE,
    };

    const response = await apiServices.fetchQuestionsReadingWise(payload);
    if (!response.success) return;

    let questions = response.result || [];

    const isSubscribed = !!+subscription;
    if (!isSubscribed) {
      questions = questions.filter((question) => +question.free === 1);
    }

    await this.handleSetCurrentQuestion(questions);
    this.setState({
      questionData: questions,
      isUserSubscribed: isSubscribed,
      isLoading: false,
    });
  }
  componentDidUpdate() {
    this.setupDropdownListeners();
  }
  setupDropdownListeners() {
    const select1 = this.dropdown1Ref && this.dropdown1Ref.querySelector('select');
    const select2 = this.dropdown2Ref && this.dropdown2Ref.querySelector('select');

    if (select1) {
      select1.value = this.state.statement1 || 'none';
      select1.onchange = (e) => {
        this.setState({ statement1: e.target.value, isError: false });
      };
    }

    if (select2) {
      select2.value = this.state.statement2 || 'none';
      select2.onchange = (e) => {
        this.setState({ statement2: e.target.value, isError: false });
      };
    }
  }
  setUserSelectedChoices = (index, questions) => {
    const questionData = questions || this.state.questionData;
    const currentQuestion = questionData[index];
    const { stateTableName = 'gmat_focus_question_stat' } = this.props;
    const stat = currentQuestion[stateTableName];

    const { selectedOptions, extraState } = getUserSelectedChoices({
      question: currentQuestion,
      stat,
      config: graphicalStatementConfig,
    });
    if (selectedOptions && extraState.statement1 && extraState.statement2) {
      this.setState({ ...extraState, selectedOptions }, () => {
        this.handleValidate(false);
      });
    }
  };

  handleSetCurrentQuestion = async (questions) => {
    this.setState({ isLoading: true });
    const { question_id: questionId } = this.props.params;
    const index = questions.findIndex((question) => question.id === +questionId) || 0;

    const selectedIndex = index > -1 ? index : 0;
    const currentQuestion = questions[selectedIndex];

    this.setState({
      currentIndex: selectedIndex,
      currentQuestion,
      isLoading: false,
    });

    if (currentQuestion) {
      this.getSavedQuestion(currentQuestion.id);
      this.getQuestionRating(currentQuestion.id);
      if (this.isRevisionMode) {
        this.setUserSelectedChoices(selectedIndex, questions);
      } else {
        this.resetStates();
      }
    }
  };

  handleSaveQuestion = async () => {
    const { questionId, reading, bookmarkCSS } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { readingid: reading_id, question_id, reading: topic_name },
    } = this.props;

    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';

    const payload = {
      question_id,
      type,
      topic_name,
      reading_id,
    };

    const endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
    const response = await endpoint(payload);

    if (isSaved && this.childRef) {
      this.childRef.deleteFlash();
    }

    this.setState({
      bookmarkCSS: isSaved
        ? 'fa fa-bookmark-o mark-action-btn-bookmark'
        : 'fa fa-bookmark mark-action-btn-bookmark',
      bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
      saveTooltipTitle: isSaved ? messages.SAVE_ITEM_DESCRIPTION : messages.QUESTION_SAVED,
      isFlashCardHidden: isSaved,
    });
  };

  getSavedQuestion = async (questionId) => {
    const { apiServices, params, questionType: type } = this.props;
    const { chapterid: chapter_id } = params;

    const payload = {
      question_id: questionId,
      chapter_id,
      type,
    };
    const response = await apiServices.fetchSavedQuestion(payload);
    this.setState({
      isFlashCardHidden: !response.success,
      ...(response.success && {
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveTooltipTitle: `${messages.QUESTION_SAVED}`,
        isFlashCardHidden: false,
      }),
    });
  };

  getQuestionRating = async (question_id) => {
    const { apiServices, questionType: type } = this.props;
    const params = {
      question_id,
      type,
    };

    try {
      const response = await apiServices.fetchRating(params);

      const { success, ratting } = response;
      if (success && ratting && ratting.length > 0) {
        //TODO Change the API and fetch rating in object not array
        const questionRating = response.ratting[0].ratting;

        this.setState({
          questionRating,
          questionRatingTitle: messages.RATED,
        });
      }
    } catch (error) {
      console.error('Error handling....', error);
    }
  };

  handleQuestionRating = async (item, nextValue, prevValue, name) => {
    const question_id = item.id;
    const { apiServices, questionType: type } = this.props;

    try {
      // Only update if the rating changed
      if (prevValue !== nextValue) {
        const updatePayload = { question_id, ratting: nextValue, type };
        const updateRatingResponse = await apiServices.updateQuestionRating(updatePayload);

        if (updateRatingResponse.success) {
          this.setState({ questionRatingTitle: messages.RATED });
        }
      }

      this.setState({ rating: nextValue });

      // Check if a rating already exists
      const fetchPayload = { question_id, type };
      const response = await apiServices.fetchRating(fetchPayload);

      const { success, ratting } = response;
      if (success && ratting && ratting.length > 0) {
        //TODO Change the API and fetch rating in object not array
        const latestRating = response.ratting[0].ratting;
        this.setState({
          questionRating: latestRating,
          questionRatingTitle: `${messages.RATED}`,
        });
      } else {
        // Save a new rating
        const savePayload = {
          question_id,
          ratting: nextValue,
          type,
        };
        const saveRatingResponse = await apiServices.saveRating(savePayload);

        if (saveRatingResponse.success) {
          this.setState({
            questionRatingTitle: messages.RATED,
            questionRating: nextValue,
          });
        }
      }
    } catch (error) {
      console.error('Error handling....', error);
    }
  };

  resetStates = () => {
    this.setState({
      validated: false,
      statement1: '',
      questionRating: 0,
      statement2: '',
      isError: false,
      selectedOptions: {},
      isUserSelectedChoice: false,
      isReportCardHidden: true,
      isFlashCardHidden: true,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
    });
  };

  redirectToNextPreviousQuestion = (index) => {
    const { questionData, isUserSubscribed } = this.state;
    const { handleChangeParams, params } = this.props;
    const currentQuestion = questionData[index];

    if (!currentQuestion) return;

    handleChangeParams({ index, question_id: currentQuestion.id });

    this.setState({
      currentIndex: index,
      currentQuestion,
    });

    this.getSavedQuestion(currentQuestion.id);
    this.getQuestionRating(currentQuestion.id);
  };

  getPreviousQuestion = async () => {
    const { currentIndex } = this.state;
    if (currentIndex > 0) {
      this.redirectToNextPreviousQuestion(currentIndex - 1);
      this.resetStates();
      if (this.isRevisionMode) this.setUserSelectedChoices(currentIndex - 1);
    }
  };

  getNextQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    const nextIndex = currentIndex + 1;
    if (nextIndex < questionData.length) {
      this.redirectToNextPreviousQuestion(nextIndex);
      this.resetStates();
      if (this.isRevisionMode) this.setUserSelectedChoices(nextIndex);
    }
  };

  handleValidate = async (isSaveAttemptStats = true) => {
    const { statement1, statement2, selectedOptions, currentQuestion } = this.state;
    const { apiServices, questionType: type } = this.props;

    const isValidated = statement1 && statement2;
    if (!isValidated) {
      this.setState({ isError: true });
      return;
    }

    const isCorrect =
      statement1 === currentQuestion.answer_statement1.replace(/^&/, '') &&
      statement2 === currentQuestion.answer_statement2.replace(/^&/, '');

    const selectedChoice = JSON.stringify({ statement1, statement2 });

    this.setState((prevState) => ({
      validated: true,
      isUserSelectedChoice: isCorrect,
    }));
    const payload = {
      question_id: currentQuestion.id,
      right_answer: isCorrect,
      selected_choice: selectedChoice,
      type,
    };
    if (isSaveAttemptStats) {
      await apiServices.saveAttemptStats(payload);
      const { stateTableName = 'gmat_focus_question_stat' } = this.props;

      this.setState({
        questionData: this.state.questionData.map((questionDetails) =>
          questionDetails.id === currentQuestion.id
            ? {
                ...questionDetails,
                [stateTableName]: {
                  selected_choice: selectedChoice,
                  isSelectedChoice: isCorrect,
                },
              }
            : questionDetails,
        ),
      });
    }
  };

  reportCardToggle = () => {
    this.setState((prevState) => ({
      isReportCardHidden: !prevState.isReportCardHidden,
    }));
  };

  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      isUserSelectedChoice,
      validated,
      saveTooltipTitle,
      bookmarkCSS,
      bookmarkColor,
      isFlashCardHidden,
      isReportCardHidden,
      questionRating,
      questionRatingTitle,
      showCalculator,
      isError,
    } = this.state;
    const { apiServices, params, redirectTo, questionType, examName } = this.props;

    // URL params expose `:readingid` (lowercase) and `:reading`; rename to the
    // snake_case keys that the BE /reportQuestion writer expects.
    const { readingid: reading_id, question_id, type, reading: topic_name } = params;

    return (
      <div>
        <ComponentHeader title={messages.QUESTION_BANK}>
          <div>
            <CustomButton
              className='mr-1 calc-btn'
              onClick={() =>
                this.setState({
                  showCalculator: true,
                })
              }
            >
              {messages.OPEN_CALCULATOR}
            </CustomButton>
            <CustomButton className='mr-1' onClick={() => redirectTo('question')}>
              {messages.CHANGE_QUESTION}
            </CustomButton>
            <CustomButton onClick={() => redirectTo('reading')}>
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>
          {currentQuestion && Object.keys(currentQuestion).length ? (
            <CustomCard>
              <CustomCardHeader
                headingText={`${topic_name} (Q. ${currentQuestion.id})`}
                headerImage={questionBankIcon}
                arrayLength={questionData.length}
                showPreviousButton
                showNextButton
                disabledPreviousButton={currentIndex < 1}
                disabledNextButton={currentIndex >= questionData.length - 1}
                getPreviousQuestion={this.getPreviousQuestion}
                getNextQuestion={this.getNextQuestion}
              />
              <CustomCardBody>
                <Row>
                  <Col xs={12}>
                    {renderHTMLContent(currentQuestion.question, 'p')}
                    {/* If we using the renderHTMLContent selected value not working properly */}
                    <div
                      ref={this.setDropdown1Ref}
                      dangerouslySetInnerHTML={{ __html: currentQuestion.statement1 }}
                      className='statement-question-div select'
                    />
                    <div
                      ref={this.setDropdown2Ref}
                      dangerouslySetInnerHTML={{ __html: currentQuestion.statement2 }}
                      className='statement-question-div select'
                    />
                  </Col>
                </Row>
                <Row>
                  {isError && (
                    <Col sm={12} md={12} lg={12} className='text-danger text-left  mb-0 pb-0'>
                      {messages.SELECT_OPTION_ERROR}
                    </Col>
                  )}
                  <Col xs={6} lg={6} sm={6} className='text-center mt-3 d-flex'>
                    {/* // TODO: Optimize this code in the future and remove the CSS states from component state */}
                    <ValidateSaveReportIcon
                      isQue={true}
                      showResult={validated}
                      _getResult={this.handleValidate}
                      _saveQuestion={this.handleSaveQuestion}
                      _displayReportForm={this.reportCardToggle}
                      all_questions={questionData}
                      save_text={saveTooltipTitle}
                      bookmarkCSS={bookmarkCSS}
                      bookmarkColor={bookmarkColor}
                    />
                  </Col>
                  <Col
                    xs={6}
                    lg={6}
                    sm={6}
                    className='text-center mt-3 d-flex align-items-center justify-content-end'
                  >
                    <span className='margin_bottom_0 margin_right_10'>{questionRatingTitle}:</span>
                    <RatingComponent
                      rating={questionRating}
                      onChange={(nextValue, prevValue, name) =>
                        this.handleQuestionRating(currentQuestion, nextValue, prevValue, name)
                      }
                    />
                  </Col>
                </Row>
              </CustomCardBody>
            </CustomCard>
          ) : (
            <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
          )}
        </LoaderWrapper>

        {validated && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={isUserSelectedChoice ? messages.CORRECT : messages.INCORRECT}
                  className={`text-uppercase ${isUserSelectedChoice ? 'text_success' : 'text_failure'}`}
                />
                <CustomCardBody>
                  {renderHTMLContent(currentQuestion.explanation, 'span')}
                </CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}
        <FlashCard
          item={{ id: currentQuestion && currentQuestion.id }}
          type={QUESTION_TYPE.QUESTION}
          question_type={questionType}
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam={examName}
        />
        {/* //TODO: Remove the !from the common component */}
        <ReportComponent
          visible={!isReportCardHidden}
          apiServices={apiServices}
          payload={{
            question_id,
            type,
            topic_name,
            reading_id,
          }}
        />
        <GMATCalculator
          show={showCalculator}
          closeModal={() => this.setState({ showCalculator: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/GraphicalStatement.jsx